<span style="opacity: 0.6; pointer-events: none;" >
    <slot />
</span>